/**
 * 主题管理上下文
 * 用于在全局范围内管理和切换亮色 (light) 与暗色 (dark) 主题
 */
import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  // 全局永久锁定白天模式 (light)
  const theme = 'light';

  useEffect(() => {
    // 将 data-theme 属性应用到 html 标签
    document.documentElement.setAttribute('data-theme', 'light');
    // 在 body 上添加 light-theme 并确保移除 dark-theme
    document.body.classList.add('light-theme');
    document.body.classList.remove('dark-theme');
    // 固化存储为 light
    localStorage.setItem('theme', 'light');
  }, []);

  const toggleTheme = () => {
    // 永久保持白天模式，禁用切换
  };

  const setTheme = () => {
    // 永久保持白天模式，禁用切换
  };

  const value = {
    theme: 'light',
    setTheme,
    toggleTheme,
    isLight: true,
    isDark: false,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export default ThemeContext;
